export class ChangePurchaseValueInputDto {
    newValue: number
    chargeId?: string
}

export class ChangePurchaseDueDateInputDto {
    simulation: boolean
    newDueDay: number
    proRata: boolean
}

export class ChangePurchaseDueDateOutputDto {
    simulation: boolean
    proRata: number
    chargeCanceled: {
        dueDate: Date
        value: number
    }
    chargeCreated: {
        dueDate: Date
        value: number
        days: number
    }
}
